import { API_CONFIG } from '../config/api';

const baseUrl = API_CONFIG.BASE_URL;

const API_ROUTES = {
  AUTH: {
    login: () => `${baseUrl}/login`,
    signup: () => `${baseUrl}/signup`,
    refresh: (refreshToken: string) => `${baseUrl}/refresh/${refreshToken}`,
    passwordRecovery: () => `${baseUrl}/password/recovery`,
    changePassword: () => `${baseUrl}/password/change`,
    defaultPassword: () => `${baseUrl}/password/default`,
  },
  HOME: {
    list: () => `${baseUrl}/home`,
  },
  CONTENTS: {
    list: () => `${baseUrl}/contents`,
    available: () => `${baseUrl}/contents/available`,
    create: () => `${baseUrl}/contents`,
    update: (id: string) => `${baseUrl}/contents/${id}`,
    delete: (id: string) => `${baseUrl}/contents/${id}`,
    get: (id: string) => `${baseUrl}/contents/${id}`,
  },
  USERS: {
    list: () => `${baseUrl}/users`,
    create: () => `${baseUrl}/users`,
    update: (id: string) => `${baseUrl}/users/${id}`,
    delete: (id: string) => `${baseUrl}/users/${id}`,
    get: (id: string) => `${baseUrl}/users/${id}`,
    accesses: (id: string) => `${baseUrl}/users/${id}/accesses`,
    profile: () => `${baseUrl}/users/profile`, // Perfil do usuário logado
  },
  MATERIALS: {
    list: () => `${baseUrl}/materials`,
    create: () => `${baseUrl}/materials`,
    update: (id: string) => `${baseUrl}/materials/${id}`,
    delete: (id: string) => `${baseUrl}/materials/${id}`,
    get: (id: string) => `${baseUrl}/materials/${id}`,
    showcase: () => `${baseUrl}/showcase`,
    reorder: () => `${baseUrl}/materials/index`,
  },
  ACCESSES: {
    list: () => `${baseUrl}/accesses`,
    create: () => `${baseUrl}/accesses`,
    update: (id: string) => `${baseUrl}/accesses/${id}`,
    delete: (id: string) => `${baseUrl}/accesses/${id}`,
    updateUserAccesses: (userId: string) => `${baseUrl}/accesses/users/${userId}`,
  },
  HEALTH: {
    alive: () => `${baseUrl}/alive`,
  },
  TEMPLATES: {
    list: () => `${baseUrl}/templates`,
    create: () => `${baseUrl}/templates`,
    update: (id: string) => `${baseUrl}/templates/${id}`,
    delete: (id: string) => `${baseUrl}/templates/${id}`,
    get: (id: string) => `${baseUrl}/templates/${id}`,
  },
  NOTIFICATIONS: {
    list: () => `${baseUrl}/notifications`,
    create: () => `${baseUrl}/notifications`,
    delete: (id: string) => `${baseUrl}/notifications/${id}`,
  },
  SOCIALS: {
    list: () => `${baseUrl}/socials`,
    create: () => `${baseUrl}/socials`,
    delete: (id: string) => `${baseUrl}/socials/${id}`,
  },
};

export default API_ROUTES;
